import React, { useState } from 'react'
import { Box, CardActionArea, CardContent, Typography } from '@mui/material'
import { Bar, BarChart, CartesianGrid, Legend, Line, ResponsiveContainer, XAxis, YAxis, Tooltip as RechartsTooltip } from 'recharts'
import { useTranslation } from 'react-i18next'

export type BarDataItem = {
  week: string
  weekFormatt: string
  trainedDays: number
  workoutQuantity: number
}

type Props = {
  barData?: BarDataItem[]
}

export const BarChartFrequency = ({ barData }: Props) => {
  const { t } = useTranslation()
  const data = barData
  const isEmpty = !data || data.length === 0
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const dataLoad = payload[0].payload
      return (
        <div style={{ backgroundColor: '#333', padding: '8px', borderRadius: '8px', color: '#fff', fontSize: 12 }}>
          <p><strong>{dataLoad.weekFormatt}</strong></p>
          <p>Treinos a realizar: {dataLoad.workoutQuantity}</p>
          <p>Treinos realizados: {dataLoad.trainedDays}</p>
        </div>
      )
    }
    return null
  }

  const renderChart = () => {
    if (isEmpty) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          textAlign="center"
          px={2}
        >
          <Typography variant="body1" color="#fff">
            {t('dashboard.emptyState.chartMessage')}
          </Typography>
        </Box>
      )
    }

    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{ top: 40, right: 5, left: 5, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" tickMargin={6} fontWeight="bold" tick={{ fill: '#fff', fontSize: 13 }} />
          <YAxis tickMargin={10} tick={{ fill: '#fff', fontSize: 13 }} />
          <RechartsTooltip cursor={false} content={<CustomTooltip />} />
          <Legend
            layout="horizontal"
            verticalAlign="bottom"
            align="center"
            formatter={(value) => (
              <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 14 }}>{value}</span>
            )}
          />
          <Bar dataKey="trainedDays" barSize={20} name="Semana" legendType="rect" fill="#d6500d" style={{ cursor: 'pointer' }} />
          <Line
            type="monotone"
            dataKey="trainedDays"
            stroke="#f2f1beff"
            strokeWidth={3}
            legendType='none'
            label={{ dy: -10, dx: 0, position: 'top', fill: '#fff', fontSize: 13, fontWeight: 'bold' }} />
        </BarChart>
      </ResponsiveContainer>
    )
  }

  return (
    <CardActionArea sx={{ height: '100%' }} >
      <CardContent>
        <Typography fontSize={25} fontWeight="bold" color="#d6500d">Frequência dos Alunos</Typography>
        <Box sx={{ width: '100%', height: 300 }}>
          {renderChart()}
        </Box>
      </CardContent>
    </CardActionArea>
  )
}
